/* properties.js — runtime API URL detection */

const ENV_MAP = {
  "localhost":                "http://localhost:8080",
  "euvdpp.enisa.europa.eu":  "https://euvdppservices.enisa.europa.eu/api",
  "euvd.enisa.europa.eu":    "https://euvdservices.enisa.europa.eu/api",
};

const hostname = window.location.hostname;

export const appUrl =
  ENV_MAP[hostname] ||
  process.env.REACT_APP_URL ||
  "https://euvdservices.enisa.europa.eu/api";
